import { getApplicationId, getIsSalesForce } from '@fnol/library/src/lib';
import { translations } from './consts';
import { FirstWaitingPeriodMessage } from '../components/WaitingPeriodMesages/FirstWaitingPeriodMessage';

const waitingPeriodMessagesStepsComposer = () => [
    {
        path: '/stepOne',
        screen: FirstWaitingPeriodMessage,
        step: 0,
        label: translations.stepLabel.START,
    },
];

export default waitingPeriodMessagesStepsComposer;
